import axios from "axios";

export interface CategoryCheck {
  id?: string;
  code?: string;
  description?: string;
}

export interface Category {
  id?: string;
  name?: string;
  description?: string;
  checks?: CategoryCheck[];
}

export interface CategoryCreateRequest {
  name: string;
  description?: string;
  checks?: string[];
}

export interface CategoryUpdateRequest {
  id: string;
  name: string;
  description?: string;
  checks?: string[];
}

export const fetchCategoryList = (): Promise<Category[]> =>
  axios.get("/category").then((resp) => (Array.isArray(resp.data) ? resp.data : []));

export const fetchCategoryById = (id: string): Promise<Category> =>
  axios.get(`/category/${id}`).then((resp) => resp.data);

export const createCategory = (data: CategoryCreateRequest): Promise<Category> =>
  axios.post("/category", data).then((resp) => resp.data);

export const updateCategory = (id: string, data: CategoryUpdateRequest): Promise<Category> =>
  axios.put(`/category/${id}`, data).then((resp) => resp.data);
